import { render, staticRenderFns } from "./wty-select.vue?vue&type=template&id=23522f56&scoped=true&"
import script from "./wty-select.vue?vue&type=script&lang=js&"
export * from "./wty-select.vue?vue&type=script&lang=js&"
import style0 from "./wty-select.vue?vue&type=style&index=0&id=23522f56&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23522f56",
  null
  
)

export default component.exports